// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"99e058ab","901":"e68826e7"}[chunkId] + ".chunk.js";
};